export default "__VITE_ASSET__BBCYy3oQ__"